export default __webpack_public_path__ + "static/logo-footer-90f35716bb9f5455a1c489142f3783ba.svg";